module.exports = __webpack_public_path__ + "static/media/acceptTerms.a716b9d1.svg";